<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import type { Difficulty } from './types';
  import { WORD_CATEGORIES, DIFFICULTY_SETTINGS } from './types';

  export let difficulty: Difficulty = 'medium';
  export let category: string = '';
  export let flashing: boolean = false;

  const dispatch = createEventDispatcher();

  function handleDifficultyChange(e: Event) {
    const target = e.target as HTMLSelectElement;
    dispatch('difficultyChange', target.value);
  }

  function handleCategoryChange(e: Event) {
    const target = e.target as HTMLSelectElement;
    dispatch('categoryChange', target.value);
  }

  function handleNewGame() {
    dispatch('newGame');
  }
</script>

<div class="settings-panel">
  <div class="settings-group">
    <label class="settings-label" for="difficulty-select">
      <span class="label-icon">🎯</span> Difficulty
    </label>
    <select
      id="difficulty-select"
      class="settings-select"
      value={difficulty}
      on:change={handleDifficultyChange}
    >
      {#each Object.entries(DIFFICULTY_SETTINGS) as [key, setting]}
        <option value={key}>{setting.label} ({setting.maxWrong} wrong)</option>
      {/each}
    </select>
  </div>

  <div class="settings-group">
    <label class="settings-label" for="category-select">
      <span class="label-icon">📂</span> Category
    </label>
    <select
      id="category-select"
      class="settings-select"
      value={category}
      on:change={handleCategoryChange}
    >
      <option value="">All Categories</option>
      {#each WORD_CATEGORIES as cat}
        <option value={cat.name}>{cat.name}</option>
      {/each}
    </select>
  </div>

  <button class="btn btn-new-game" class:flashing on:click={handleNewGame}>
    <span class="btn-icon">🔄</span> New Game
  </button>
</div>

<style>
  .settings-panel {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-end;
    padding: 16px;
    background: var(--panel-bg, #f8f9fa);
    border-radius: 12px;
    border: 1px solid var(--panel-border, #e9ecef);
  }

  .settings-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 140px;
  }

  .settings-label {
    font-size: 13px;
    font-weight: 600;
    color: #555;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .label-icon {
    font-size: 16px;
  }

  .settings-select {
    padding: 8px 12px;
    border: 2px solid #dee2e6;
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    background: white;
    cursor: pointer;
    transition: border-color 0.2s;
    appearance: auto;
  }

  .settings-select:focus {
    border-color: #4a90d9;
    outline: none;
  }

  .btn {
    padding: 8px 20px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .btn-new-game {
    background: #4a90d9;
    color: white;
    transition: all 0.2s ease;
  }

  .btn-new-game:hover {
    background: #357abd;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(74, 144, 217, 0.3);
  }

  .btn-new-game.flashing {
    background: #27ae60 !important;
    transform: scale(1.05) !important;
  }

  .btn-icon {
    font-size: 16px;
  }
</style>
